<template>
	<section class="c-priority-listing">
		<template v-if="displayContent == 'loading'">
			<h3>Loading</h3>
		</template>

		<template v-if="displayContent == 'reject'">
			<h3>Oops</h3>
			<p>We're sorry, you don't have access to book tickets yet.</p>
			<!-- <p>Currently open to <span v-html="decodeURI(this.$props.currentOnSaleSchedule.statusName)"></span></p>  -->
		</template>

		<template v-else-if="displayContent == 'login'">
			<spektrix-login
				class="c-priority-upsell__login"
				:spektrix-url="importUrl"
				:show-logout="false"
				:show-back="false"
				@logged-in="checkTags()"
			></spektrix-login>
		</template>
	</section>
</template>

<script>
	import crossIcon from "/web/static/images/svgs/base-cross.svg?component";
	import spektrixLogin from "../spektrix-login.vue";

	export default {
		name: "priority-popup",
		components: {
			crossIcon,
			spektrixLogin,
		},
		data: function () {
			return {
				loading: false,
				displayContent: this.$props.shownContent,
			};
		},
		props: {
			currentOnSaleSchedule: {
				type: Object,
			},
			shownContent: {
				type: String,
				default: "login",
			},
			href: {
				type: String,
			},
			importUrl: {
				type: String,
			},
		},
		created() {
			//this.checkTags()
		},
		methods: {
			checkTags() {
				const self = this;
				self.displayContent = "loading";

				self.$store
					.dispatch("getSpektrixCustomer", {
						url: self.importUrl,
					})
					.then(function (response) {
						var tags = response.tags;

						if (self.currentOnSaleSchedule.tags && tags) {
							//console.log(self.$props.statusData[0].tags, tags[i].id, self.$props.statusData[0].tags.indexOf(tags[i].id))
							for (var i = 0; i < tags.length; i++) {
								if (self.currentOnSaleSchedule.tags.indexOf(tags[i].id) >= 0) {
									self.tagAuthenticated = true;
								}
							}

							if (self.tagAuthenticated) {
								// self.$log.debug('customer has required tags');

								if (self.$props.href) {
									window.location.href = self.$props.href;
								} else {
									window.location.href = window.location.pathname + "#dates";
								}
							} else {
								//customer does not have the required tags
								self.displayContent = "reject";
							}
						} else {
							//customer does not have the required tags
							self.displayContent = "reject";
						}
					})
					.catch(function (error) {
						console.log(error);

						self.displayContent = "login";
					});
			},
		},
	};
</script>
